const C = require("../constants");

const ticketClientDialogActions = (data) => {
    return {
        type: C.TICKET_CLIENT_DIALOG,
        data
    }
};

export {ticketClientDialogActions};


// WEBPACK FOOTER //
// ./src/actions/TicketClientDialogActions.js